import React from 'react'
import { Link } from 'react-router-dom'
import Event02 from '../../../assets/image/event/event-2.jpg'
import Event03 from '../../../assets/image/event/event-3.jpg'
import Event04 from '../../../assets/image/event/event-4.jpg'
import Event06 from '../../../assets/image/event/event-6.jpg'
import Event07 from '../../../assets/image/event/event-7.jpg'
import Event08 from '../../../assets/image/event/event-8.jpg'

function First() {
  return (
    <>
        <section className="event-three-section">
            <div className="event-section-outer">
                <div className="container">
                <div className="row row-gutter-y-30">
                    <div className="col-12 col-lg-6 col-xl-6">
                    <div className="event-card">
                        <div className="event-card-image">
                        <div className="event-card-image-inner">
                            <Link to="/eventdetails">
                                <img src={Event02} className="img-fluid" alt="img-164" />
                            </Link>
                            <div className="event-card-meta">
                            <div className="event-meta-number">
                                <span>28</span>
                            </div>
                            
                            <div className="event-meta-date">
                                <span>October 2022</span>
                            </div>
                           
                            </div>
                          
                        </div>
                        
                        </div>
                        
                        <div className="event-card-content">
                        <div className="event-card-info">
                            <ul className="list-unstyled">
                            <li>
                                <i className="fa-solid fa-clock" />
                                <span>08:00am - 05:00pm</span>
                            </li>
                           
                            <li>
                                <i className="fa-sharp fa-solid fa-location-pin" />
                                <span>New Hyde Park, NY 11040</span>
                            </li>
                           
                            </ul>
                            
                        </div>
                        
                        <div className="event-card-title">
                            <h4>
                            <Link to="/eventdetails">
                                Organizing 2022 city photography new contest
                            </Link>
                            </h4>
                        </div>
                        
                        </div>
                       
                    </div>
                    
                    </div>
                    
                    <div className="col-12 col-lg-6 col-xl-6">
                    <div className="event-card">
                        <div className="event-card-image">
                        <div className="event-card-image-inner">
                            <Link to="/eventdetails">
                            <img src={Event03} className="img-fluid" alt="img-165" />
                            </Link>
                            <div className="event-card-meta">
                            <div className="event-meta-number">
                                <span>28</span>
                            </div>
                            
                            <div className="event-meta-date">
                                <span>October 2022</span>
                            </div>
                           
                            </div>
                          
                        </div>
                        
                        </div>
                        
                        <div className="event-card-content">
                        <div className="event-card-info">
                            <ul className="list-unstyled">
                            <li>
                                <i className="fa-solid fa-clock" />
                                <span>08:00am - 05:00pm</span>
                            </li>
                           
                            <li>
                                <i className="fa-sharp fa-solid fa-location-pin" />
                                <span>New Hyde Park, NY 11040</span>
                            </li>
                           
                            </ul>
                            
                        </div>
                        
                        <div className="event-card-title">
                            <h4>
                            <Link to="/eventdetails">
                                Organizing 2022 city photography new contest
                            </Link>
                            </h4>
                        </div>
                        
                        </div>
                       
                    </div>
                    
                    </div>
                    
                    <div className="col-12 col-lg-6 col-xl-6">
                    <div className="event-card">
                        <div className="event-card-image">
                        <div className="event-card-image-inner">
                            <Link to="/eventdetails">
                            <img src={Event04} className="img-fluid" alt="img-166" />
                            </Link>
                            <div className="event-card-meta">
                            <div className="event-meta-number">
                                <span>28</span>
                            </div>
                            
                            <div className="event-meta-date">
                                <span>October 2022</span>
                            </div>
                           
                            </div>
                          
                        </div>
                        
                        </div>
                        
                        <div className="event-card-content">
                        <div className="event-card-info">
                            <ul className="list-unstyled">
                            <li>
                                <i className="fa-solid fa-clock" />
                                <span>08:00am - 05:00pm</span>
                            </li>
                           
                            <li>
                                <i className="fa-sharp fa-solid fa-location-pin" />
                                <span>New Hyde Park, NY 11040</span>
                            </li>
                           
                            </ul>
                            
                        </div>
                        
                        <div className="event-card-title">
                            <h4>
                            <Link to="/eventdetails">
                                Organizing 2022 city photography new contest
                            </Link>
                            </h4>
                        </div>
                        
                        </div>
                       
                    </div>
                    
                    </div>
                    
                    <div className="col-12 col-lg-6 col-xl-6">
                    <div className="event-card">
                        <div className="event-card-image">
                        <div className="event-card-image-inner">
                            <Link to="/eventdetails">
                            <img src={Event06} className="img-fluid" alt="img-167" />
                            </Link>
                            <div className="event-card-meta">
                            <div className="event-meta-number">
                                <span>28</span>
                            </div>
                            
                            <div className="event-meta-date">
                                <span>October 2022</span>
                            </div>
                           
                            </div>
                          
                        </div>
                        
                        </div>
                        
                        <div className="event-card-content">
                        <div className="event-card-info">
                            <ul className="list-unstyled">
                            <li>
                                <i className="fa-solid fa-clock" />
                                <span>08:00am - 05:00pm</span>
                            </li>
                           
                            <li>
                                <i className="fa-sharp fa-solid fa-location-pin" />
                                <span>New Hyde Park, NY 11040</span>
                            </li>
                           
                            </ul>
                            
                        </div>
                        
                        <div className="event-card-title">
                            <h4>
                            <Link to="/eventdetails">
                                Organizing 2022 city photography new contest
                            </Link>
                            </h4>
                        </div>
                        
                        </div>
                       
                    </div>
                    
                    </div>
                    
                    <div className="col-12 col-lg-6 col-xl-6">
                    <div className="event-card">
                        <div className="event-card-image">
                        <div className="event-card-image-inner">
                            <Link to="/eventdetails">
                            <img src={Event07} className="img-fluid" alt="img-168" />
                            </Link>
                            <div className="event-card-meta">
                            <div className="event-meta-number">
                                <span>28</span>
                            </div>
                            
                            <div className="event-meta-date">
                                <span>October 2022</span>
                            </div>
                           
                            </div>
                          
                        </div>
                        
                        </div>
                       
                        <div className="event-card-content">
                        <div className="event-card-info">
                            <ul className="list-unstyled">
                            <li>
                                <i className="fa-solid fa-clock" />
                                <span>08:00am - 05:00pm</span>
                            </li>
                           
                            <li>
                                <i className="fa-sharp fa-solid fa-location-pin" />
                                <span>New Hyde Park, NY 11040</span>
                            </li>
                           
                            </ul>
                            
                        </div>
                        
                        <div className="event-card-title">
                            <h4>
                            <Link to="/eventdetails">
                                Organizing 2022 city photography new contest
                            </Link>
                            </h4>
                        </div>
                        
                        </div>
                       
                    </div>
                    
                    </div>
                    
                    <div className="col-12 col-lg-6 col-xl-6">
                    <div className="event-card">
                        <div className="event-card-image">
                        <div className="event-card-image-inner">
                            <Link to="/eventdetails">
                            <img src={Event08} className="img-fluid" alt="img-169" />
                            </Link>
                            <div className="event-card-meta">
                            <div className="event-meta-number">
                                <span>28</span>
                            </div>
                            
                            <div className="event-meta-date">
                                <span>October 2022</span>
                            </div>
                           
                            </div>
                           
                        </div>
                        
                        </div>
                        
                        <div className="event-card-content">
                        <div className="event-card-info">
                            <ul className="list-unstyled">
                            <li>
                                <i className="fa-solid fa-clock" />
                                <span>08:00am - 05:00pm</span>
                            </li>
                           
                            <li>
                                <i className="fa-sharp fa-solid fa-location-pin" />
                                <span>New Hyde Park, NY 11040</span>
                            </li>
                           
                            </ul>
                            
                        </div>
                        
                        <div className="event-card-title">
                            <h4>
                            <Link to="/eventdetails">
                                Organizing 2022 city photography new contest
                            </Link>
                            </h4>
                        </div>
                        
                        </div>
                       
                    </div>
                    
                    </div>
                    
                </div>
               
                </div>
                
            </div>
        </section>
    </>
  )
}

export default First